import DashboardList from "./DashboardList";

export default DashboardList;
